<template>
  <v-content>
    <v-container fluid grid-list-lg>
      <h1 class="py-3">Alert Groups</h1>
      <v-card>
        <!-- Select alert -->
        <h3 class="pl-4 pt-4">Select Alert</h3>
        <v-layout>
          <v-flex xs12 sm4>
            <v-select
              class="pl-4"
              label="Alert"
              :items="alerts"
              item-text="alertname"
              @input="onSelectAlert"
              ref="selectedAl"
              return-object
            ></v-select>
          </v-flex>
        </v-layout>

        <h3 class="pl-4">Select Devices</h3>
        <v-layout>
          <!-- Select organisation -->
          <v-flex xs12 sm6>
            <v-select
              class="pl-4"
              label="Organisations"
              :items="organisations"
              item-text="companyname"
              @input="onSelectOrganisation"
              ref="selectedOr"
              return-object
            ></v-select>
          </v-flex>

          <!-- Select project group -->
          <v-flex xs12 sm6>
            <v-select
              v-if="projectGroups"
              label="Project Groups"
              :items="projectGroups"
              item-text="groupname"
              @input="onSelectProjectgroup"
              return-object
            ></v-select>
          </v-flex>

          <!-- Select device type -->
          <v-flex xs12 sm6>
            <v-select
              v-if="deviceTypes"
              class="pr-4"
              label="Device Type"
              :items="deviceTypes"
              item-text="typename"
              @input="onSelectDeviceType"
            ></v-select>
          </v-flex>
        </v-layout>
        <!-- v-if="devices.length > 0 && alertGroups.length > 0" -->
      </v-card>

      <v-card class="my-4">
        <DualSelectLists
          @onListChange="onListChange"
          @onSubmit="onListSubmit"
          @onReset="onListReset"
          :leftItems="filteredDevices"
          :rightItems="alertGroups"
          :leftHeaders="deviceHeaders"
          :rightHeaders="deviceHeaders"
          :leftTitle="'Devices'"
          :rightTitle="alertName ? `Alert Group Devices in ${alertName}`: 'Alert Group Devices' "
        ></DualSelectLists>
        <v-snackbar
          v-model="snackBar.visible"
          auto-height
          :color="snackBar.color"
          :multi-line="snackBar.mode === 'multi-line'"
          :timeout="snackBar.timeout"
          :right="snackBar.position === 'right'"
        >
          <v-layout align-center pr-4>
            <v-icon class="pr-3" dark large>{{ snackBar.icon }}</v-icon>
            <v-layout column>
              <div>
                <strong>{{ snackBar.title }}</strong>
              </div>
              <div>{{ snackBar.text }}</div>
            </v-layout>
          </v-layout>
        </v-snackbar>
      </v-card>
    </v-container>
  </v-content>
</template>

<script>
import DualSelectLists from '@/components/Common/DualSelectLists'

export default {
  name: 'AlertGroup',
  components: {
    DualSelectLists
  },

  data: () => {
    return {
      alertGroups: [],
      devices: [],
      filteredDevices: [],
      alertName: '',
      alertID: null,
      // alertGroups: [{alert_id:1,device:[{devicename:'C41138',id:1,identity_data:{displayname:'50 SALEM STREET , Southampton, Hampshire, SO15 5QD',loc_lat:50.9249821,loc_lon:-1.4281158}}],device_id:1,id:1044},{alert_id:1,device:[{devicename:'C46498',id:3,identity_data:{displayname:'92 UPPER SHIRLEY AVENUE, Southampton, Hampshire, SO15 5NN',loc_lat:50.9245738,loc_lon:-1.4255598}}],device_id:3,id:1045},{alert_id:1,device:[{devicename:'C45BFB',id:2,identity_data:{displayname:'25 SHIRLEY AVENUE , Southampton, Hampshire, SO15 5NF',loc_lat:50.9220017,loc_lon:-1.4291909}}],device_id:2,id:1046}],
      alerts: [],
      organisations: [],
      projectGroups: null,
      deviceTypes: null,
      alertGroupHeaders: [
        { text: 'ID', value: 'device.id' },
        { text: 'Device Name', value: 'device.devicename' },
        { text: 'Location', value: 'device.identity_data.displayname' }
      ],
      deviceHeaders: [
        { text: 'ID', value: 'id' },
        { text: 'Device Name', value: 'devicename' },
        { text: 'Location', value: 'identity_data.displayname' }
      ],

      snackBar: {
        color: null,
        icon: null,
        mode: null,
        position: 'right',
        text: null,
        timeout: 2000,
        title: null,
        visible: false
      },
      timeout: 2000
    }
  },

  beforeMount () {
    this.getAlerts()
    this.getOrganisations()
  },

  methods: {
    /**
     * Get the list of alerts (called before mounting)
     */
    getAlerts () {
      this.$http
        .get('/alert')
        .then(response => {
          this.alerts = response.data.alerts
        })
        .catch(e => {
          this.printError(`Error receiving alerts ${e}`)
        })
    },

    /**
     * Get the list of organisations (called before mounting)
     */
    getOrganisations () {
      this.$http
        .get('/schemas/organisations')
        .then(response => {
          this.organisations = response.data.organisations
        })
        .catch(e => {
          this.printError(`Error receiving organisations ${e}`)
        })
    },

    /**
     * Callback for when an alert is selected from the dropdown
     * @param {Alert} alert The selected alert
     */
    onSelectAlert (alert) {
      this.$http.get(`/alert/${alert.id}`).then(response => {
        this.alertGroups = []
        // Normalise the alert group to match the format of the device array so that
        // they can be easily copied
        for (const group of response.data.alert.alertgroups) {
          this.alertGroups.push({
            group_id: group.id,
            id: group.device.id,
            devicename: group.device.devicename,
            identity_data: {
              displayname: group.device.identity_data.displayname
            }
          })
        }
        this.alertID = response.data.alert.id
        this.alertName = response.data.alert.alertname
        this.filteredDevices = this.devices.filter(this.checkIsInAlertGroup)
      })
    },

    /**
     * Callback for when an organisation is selected from the dropdown
     * @param {Organisation} organisation The selected organisation
     */
    onSelectOrganisation (organisation) {
      // Update the device list
      this.getDevices('?organisation_ids=' + organisation.id)

      // Get the child project groups
      this.$http
        .get('/schemas/projectgroups?parentid=' + organisation.id)
        .then(response => {
          this.projectGroups = response.data.projectgroups
        })
        .catch(e => {
          this.printError(`Error receiving project groups ${e}`)
        })
    },

    /**
     * Callback for when an projectGroup is selected from the dropdown
     * @param {Projectgroup} projectGroup The selected organisation
     */
    onSelectProjectgroup (projectGroup) {
      // Update the device list
      this.getDevices('?projectgroup_id=' + projectGroup.id)

      // Get the child device types
      this.$http
        .get('/schemas/devicetypes?parentid=' + projectGroup.id)
        .then(response => {
          this.deviceTypes = response.data.devicetypes
        })
        .catch(e => {
          this.printError(`Error receiving device types ${e}`)
        })
    },

    /**
     * Callback for when an device type is selected from the dropdown
     * @param {Devicetype} devicetype The selected organisation
     */
    onSelectDeviceType (devicetype) {
      this.getDevices('?devicetype_id=' + devicetype.id)
    },

    /**
     * Gets devices based on the passed in query string, which can be:
     *    ?organisation_ids=...
     *    ?projectgroup_id=...
     *    ?devicetype_id=...
     * @param {String} queryParam The query param to add to the device list request
     */
    getDevices (queryParam) {
      const url = '/schemas/devices' + queryParam
      this.$http.get(url).then(response => {
        this.devices = response.data.devices
        this.filteredDevices = this.devices.filter(this.checkIsInAlertGroup)
      })
    },

    /**
     * Check if a device is in the currently selected alert group
     * @param {Device} device The device to check
     */
    checkIsInAlertGroup (device) {
      for (this.alertGroup of this.alertGroups) {
        if (this.alertGroup.id === device.id) {
          return false
        }
      }
      return true
    },

    onListChange ({ newLeft, newRight }) {
      this.filteredDevices = newLeft
      this.alertGroups = newRight
    },

    async onListSubmit ({ itemsRemoved, itemsAdded }) {
      let msg = ''

      // eslint-disable-next-line no-console
      console.log(itemsRemoved, itemsAdded)

      // Call endpoint for adding items if the list isn't empty
      if (itemsAdded !== undefined && itemsAdded.length > 0) {
        const newDevices = []
        for (const device of itemsAdded) {
          newDevices.push({
            alert_id: this.alertID,
            device_id: device.id
          })
        }
        try {
          const response = await this.$http.post(
            '/alertgroup/bulk',
            newDevices
          )
          // eslint-disable-next-line no-console
          console.log(response)
          msg = `${response.data.created} devices added successfully!`
        } catch (e) {
          msg = 'failed to add devices'
        }
      }

      if (itemsRemoved !== undefined && itemsRemoved.length > 0) {
        const removedGroups = []
        for (const device of itemsRemoved) {
          removedGroups.push({
            alert_group_id: device.group_id
          })
        }

        try {
          const response = await this.$http.delete('/alertgroup/bulk',
            {
              data: removedGroups
            })
          // eslint-disable-next-line no-console
          console.log(response)
          if (msg.length === 0) {
            msg = `${response.data.deleted} devices removed successfully!`
          } else {
            msg += ` & ${response.data.deleted} devices removed successfully!`
          }
        } catch (e) {
          if (msg.length === 0) {
            msg = 'failed removed devices'
          } else {
            msg += ', failed to remove devices'
          }
        }
      }
      // eslint-disable-next-line no-console
      console.log(msg)

      if (msg.length > 1) {
        this.showSnackBar('success', msg)
      } else {
        this.showSnackBar('error')
      }

      if (itemsAdded.length === 0 && itemsRemoved.length === 0) {
        this.showSnackBar('nochange')
      }
    },

    onListReset () {
      this.alertGroups = []
      this.devices = []
      this.filteredDevices = []
      this.alertName = ''
      this.alertID = null
      this.projectGroups = null
      this.deviceTypes = null
      this.showSnackBar('reset')
      this.getAlerts()

      this.$refs['selectedAl'].reset()
      this.$refs['selectedOr'].reset()
    },

    /**
     * Prints an error string
     * @param {String} err The error to print
     */
    printError (err) {
      // eslint-disable-next-line no-console
      console.error(err)
    },

    showSnackBar (type, msg) {
      switch (type) {
        case 'error':
          this.snackBar = {
            color: 'error',
            icon: 'error',
            mode: 'multi-line',
            position: 'right',
            timeout: 2000,
            title: 'Error',
            text: 'Somethings gone wrong, sorry.',
            visible: true
          }
          break
        case 'success':
          this.snackBar = {
            color: 'success',
            icon: 'check_circle',
            mode: 'multi-line',
            position: 'right',
            timeout: 2000,
            title: 'Success',
            text: msg,
            visible: true
          }
          break
        case 'reset':
          this.snackBar = {
            color: 'error',
            icon: 'refresh',
            mode: 'multi-line',
            position: 'right',
            timeout: 2000,
            title: 'Reset',
            text: 'Changes cancelled',
            visible: true
          }
          break
        case 'nochange':
          this.snackBar = {
            color: 'error',
            icon: 'warning',
            mode: 'multi-line',
            position: 'right',
            timeout: 2000,
            title: 'Error',
            text: 'No changes made!',
            visible: true
          }
      }
    }
  }
}
</script>
